import React, { useState, useEffect } from 'react';
import './MedicineBatchDetailModal.css';

const MedicineBatchDetailModal = ({ isOpen, onClose, item, itemIndex, onSave }) => {
  const [batchChecked, setBatchChecked] = useState(true);
  const [quantity, setQuantity] = useState(item?.quantity || 1);

  useEffect(() => {
    if (item) {
      setQuantity(item.quantity > 0 ? item.quantity : 1);
      setBatchChecked(true);
    }
  }, [item]);

  if (!isOpen || !item) return null;

  const packSize = item.packSize || (item.name?.includes('PANTOCID') ? 15 : 10);
  const totalMrp = parseFloat(item.mrp) || (item.name?.includes('PANTOCID') ? 252.19 : item.name?.includes('SAFELIVER') ? 439.00 : 56.25);
  const unitPrice = totalMrp / packSize;
  const discountedRate = (totalMrp * 0.762).toFixed(2);
  const calculatedPrice = (parseFloat(quantity || 0) * unitPrice).toFixed(2);
  const stock = item.stock !== undefined && item.stock !== null ? item.stock : (item.name?.includes('PANTOCID') ? 750 : item.name?.includes('SAFELIVER') ? 1166 : 1);

  const handleQtyChange = (val) => {
    const num = parseInt(val, 10);
    if (isNaN(num) || num < 0) {
      setQuantity('');
    } else {
      setQuantity(num);
    }
  };

  const handleSubmit = () => {
    const finalQty = parseInt(quantity, 10) || 1;
    onSave(itemIndex, finalQty);
    onClose();
  };

  return (
    <div className="batch-modal-backdrop" onClick={onClose}>
      <div className="batch-modal-card" onClick={(e) => e.stopPropagation()}>
        {/* Header Bar */}
        <div className="batch-modal-header">
          <div className="batch-modal-header-left">
            <span className="batch-modal-item-title">
              {itemIndex + 1})&nbsp;&nbsp;{item.name || 'MEDICINE'}
            </span>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => handleQtyChange(e.target.value)}
              className="batch-modal-top-qty-input"
              title="Quantity"
            />
          </div>
          <button className="batch-modal-close-icon" onClick={onClose} title="Close">
            ✕
          </button>
        </div>

        {/* Modal Body / Table */}
        <div className="batch-modal-body">
          <table className="batch-modal-table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}>#</th>
                <th>Batch number</th>
                <th>Expiry date</th>
                <th>Mrp</th>
                <th>Available quantity</th>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr className="batch-modal-row">
                <td style={{ textAlign: 'center' }}>
                  <input
                    type="checkbox"
                    checked={batchChecked}
                    onChange={(e) => setBatchChecked(e.target.checked)}
                    className="batch-checkbox"
                  />
                </td>
                <td>
                  <div className="batch-number-wrapper">
                    <span className="batch-info-circle">ℹ</span>
                    <strong className="batch-number-text">{item.batch || 'T25.102'}</strong>
                  </div>
                </td>
                <td className="batch-expiry-text">{item.expiry || 'Feb 28, 2027'}</td>
                <td>
                  <div className="batch-mrp-stack">
                    <span className="batch-mrp-pill">₹ {discountedRate}</span>
                    <span className="batch-pack-price">₹ {totalMrp.toFixed(2)}</span>
                    <span className="batch-pack-text">( {packSize} Pack )</span>
                  </div>
                </td>
                <td>
                  <span className="batch-avail-pill">
                    <strong>{stock}</strong>&nbsp;&nbsp;(&nbsp;{stock} Tablet{stock > 1 ? 's' : ''}&nbsp;)
                  </span>
                </td>
                <td>
                  <input
                    type="number"
                    min="1"
                    value={quantity}
                    onChange={(e) => handleQtyChange(e.target.value)}
                    className="batch-qty-input"
                    disabled={!batchChecked}
                  />
                </td>
                <td className="batch-price-cell">
                  <strong>₹ {calculatedPrice}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Modal Footer */}
        <div className="batch-modal-footer">
          <button type="button" className="batch-btn-close" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="batch-btn-submit"
            onClick={handleSubmit}
            disabled={!batchChecked || !quantity || quantity < 1}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicineBatchDetailModal;
